module.exports = __webpack_public_path__ + "static/media/easy2use.7ccb482d.png";